
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bee",
      function () {
        return require("private-next-pages/bee.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bee"])
      });
    }
  